import BadgeOutlined from '@mui/icons-material/BadgeOutlined'
import PriorityHigh from '@mui/icons-material/PriorityHigh'
import { alpha, Avatar, Skeleton, useTheme } from '@mui/material'
import { AVATAR_SIZE } from './UserAvatar'

type PositionAvatarProps = {
  loading?: boolean
  blocked?: boolean
}

/**
 * Goes wherever a `UserAvatar` would go on an approver row, but for a
 * position instead of a person. It's a square badge instead of a round face,
 * so a position is easy to tell apart from a person at a glance, before you
 * even read the label.
 */
export default function PositionAvatar({
  loading,
  blocked,
}: PositionAvatarProps) {
  const theme = useTheme()

  if (loading) {
    return (
      <Skeleton
        variant="rounded"
        width={AVATAR_SIZE}
        height={AVATAR_SIZE}
        sx={{ flex: 'none' }}
      />
    )
  }

  if (blocked) {
    return (
      <Avatar
        variant="rounded"
        sx={{
          width: AVATAR_SIZE,
          height: AVATAR_SIZE,
          bgcolor: theme.palette.warning.main,
          color: theme.palette.warning.contrastText,
        }}
      >
        <PriorityHigh sx={{ fontSize: 18 }} />
      </Avatar>
    )
  }

  return (
    <Avatar
      variant="rounded"
      sx={{
        width: AVATAR_SIZE,
        height: AVATAR_SIZE,
        bgcolor: theme.palette.blueGrey.main,
        color: alpha(theme.palette.blueGrey.contrastText, 0.75),
      }}
    >
      <BadgeOutlined sx={{ fontSize: 18 }} />
    </Avatar>
  )
}
